module.exports = __webpack_public_path__ + "img/item.307ae16c.svg";